import { CanvasTexture, Group, LinearFilter, Sprite, SpriteMaterial } from 'three';
import LatLong from '../general/LatLong';

export default class LabelManager extends Group {
  constructor(container) {
    super();
    this.textures = {};
    this.sprites = [];
    this.radius = 1.05;
    this.labelScale = 0.0004 / window.devicePixelRatio;
    this.offsetX = 0.8;
    this.offsetY = 0.0;
    this._size = 0.0;
    this.container = container;
  }

  get size() {
    return this._size;
  }

  set size(value) {
    this._size = value;

    if (value === 0.0) {
      if (!this.parent) this.container.remove(this);
    } else if (!this.parent) this.container.add(this);

    for (const sprite of this.sprites) {
      // finished looping through the relevant ones
      if (!sprite.parent) return;
      sprite.scale.x = sprite.baseWidth * this._size;
      sprite.scale.y = sprite.baseHeight * this._size;
    }
  }

  updateLabels(canvases, pins) {
    if (!canvases) canvases = [];
    const texs = this.textures;
    this.textures = {};

    for (let i = 0; i < canvases.length; ++i) {
      const canvas = canvases[i];
      const tex = getTex(canvas, texs, this.textures);

      let sprite;
      if (i >= this.sprites.length) {
        const material = new SpriteMaterial({ color: 0xffffff });
        sprite = new Sprite(material);
        sprite.center.x -= this.offsetX;
        sprite.center.y -= this.offsetY;
        sprite.layers.set(2);
        this.sprites.push(sprite);
      } else {
        sprite = this.sprites[i];
      }
      sprite.material.map = tex;
      sprite.baseWidth = this.labelScale * canvas.width;
      sprite.baseHeight = this.labelScale * canvas.height;
      sprite.scale.set(sprite.baseWidth * this._size, sprite.baseHeight * this._size, 1.0);
      this.add(sprite);
      const { location } = pins[i];
      LatLong.toVector3(
        location.lat /* + this.latOffset */,
        location.long /* - this.longOffset */,
        this.radius,
        sprite.position
      );
    }
    // console.log('canvases lenght ' + canvases.length);
    // console.log('pins lenght ' + pins.length);

    // remove any existing meshes (don't destroy them, we'll probably need them later)
    for (let i = canvases.length; i < this.sprites.length; ++i) {
      const sprite = this.sprites[i];
      if (sprite.parent) this.remove(sprite);
    }
  }
}

function getTex(canvas, srcMap, dstMap) {
  const { naturalWidth, naturalHeight } = canvas;
  const key = `${naturalWidth}x${naturalHeight}`;
  let tex;
  if (srcMap[key]) tex = srcMap[key].pop();

  if (!tex) {
    tex = new CanvasTexture(canvas);
    tex.minFilter = LinearFilter;
  } else {
    tex.image = canvas;
    tex.needsUpdate = true;
  }

  if (!dstMap[key]) dstMap[key] = [];
  dstMap[key].push(tex);

  return tex;
}
